import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AuthGuard } from '@/features/auth/guards/AuthGuard';

export const Route = createFileRoute('/_guest')({
	beforeLoad: async ({ context }) => {
		await AuthGuard.requireGuest(context.queryClient);
	},
	component: GuestLayout,
});

function GuestLayout() {
	return <Outlet />;
}
